import { getLocaleFromCountryCode } from "../../utils/countryLocaleMap";

/**
 * A locale tag `Intl` accepts, or `undefined` when the tag is malformed — an
 * invalid tag makes every `Intl` constructor throw.
 */
export function canonicaliseLocale(locale: string | null | undefined): string | undefined {
  if (!locale) return undefined;
  try {
    return Intl.getCanonicalLocales(locale.trim())[0];
  } catch {
    return undefined;
  }
}

/** The browser's own locale, or `undefined` when it reports none `Intl` accepts. */
export function getBrowserLocale(): string | undefined {
  return typeof navigator === "undefined" ? undefined : canonicaliseLocale(navigator.language);
}

/**
 * The locale the widget formats against: the browser's own, falling back to
 * the venue's when the browser reports none. `undefined` leaves `Intl` on the
 * runtime default.
 */
export function resolveWidgetLocale(venueCountryCode?: string | null): string | undefined {
  const browserLocale = getBrowserLocale();
  if (browserLocale) return browserLocale;
  return venueCountryCode?.trim() ? getLocaleFromCountryCode(venueCountryCode) : undefined;
}
